import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/svg/mobile/shevron-left.svg'


const _hoisted_1 = { class: "mt-[130px]" }
const _hoisted_2 = { class: "grid grid-cols-[22px_auto] gap-x-3 mb-[60px] px-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex items-center justify-center px-[48.5px] py-[10px] border-[3px] border-[var(--primary-color)] rounded-[100px] w-fit" }
const _hoisted_7 = { class: "px-6 mb-[60px]" }
const _hoisted_8 = { class: "flex flex-col justify-center items-center border-[3px] border-[var(--primary-color)] rounded-[50px] px-9 py-8" }
const _hoisted_9 = { class: "flex justify-center gap-x-6 mb-9" }
const _hoisted_10 = {
  key: 0,
  class: "fixed inset-0 z-30"
}
const _hoisted_11 = { class: "mb-[60px]" }
const _hoisted_12 = { class: "flex justify-center p-3 mb-[60px]" }
const _hoisted_13 = { class: "flex flex-col border-[3px] border-[var(--primary-color)] rounded-[50px] py-6 w-full" }
const _hoisted_14 = { class: "flex items-center gap-x-3 mb-3 px-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_16 = { class: "flex flex-col px-6" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "mb-[60px] px-6" }
const _hoisted_20 = { class: "p-3 mb-6" }
const _hoisted_21 = { class: "pl-5 mt-4" }
const _hoisted_22 = { class: "list-disc pl-10 mt-4" }
const _hoisted_23 = { class: "pl-5 mt-4" }
const _hoisted_24 = { class: "pl-5 mt-4" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGlobalStore } from '@/stores/global';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import BaseAccordion from '@/components/common/BaseAccordion.vue';
import TourForm from './TourForm.vue';
import MarkdownIt from 'markdown-it';


export default /*#__PURE__*/_defineComponent({
  __name: 'TourMobile',
  setup(__props) {

const strapiUrl = process.env.VUE_APP_STRAPI_URL;

const md = new MarkdownIt();

const router = useRouter();
const id = +router.currentRoute.value.params.id;

const toggle = ref<boolean>(false);
const tour = ref();

const toggleForm = () => (toggle.value = !toggle.value);

const globalStore = useGlobalStore();
const { getTour } = globalStore;

const onLoad = async () => {
    tour.value = await getTour(id);
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
        class: "mt-[7px]"
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseTypography, {
          text: tour.value?.data.attributes?.title,
          type: "subtitle-m",
          color: "var(--primary-color)",
          class: "mb-3 w-fit"
        }, null, 8, ["text"]),
        _createVNode(BaseLine, {
          width: "250",
          class: "mb-6"
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseTypography, {
            text: tour.value?.data.attributes?.days,
            type: "subtitle2-m"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: tour.value?.data?.attributes.summForGroup,
              type: "subtitle-m",
              color: "var(--secondary-color)",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: " ₽/чел",
              type: "body2-m",
              tag: "span"
            }),
            _createVNode(BaseTypography, {
              text: tour.value?.data?.attributes.group,
              type: "body-m"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: tour.value?.data?.attributes.summForInd,
              type: "subtitle-m",
              color: "var(--secondary-color)",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: " ₽/чел",
              type: "body2-m",
              tag: "span"
            }),
            _createVNode(BaseTypography, {
              text: tour.value?.data?.attributes.tourType,
              type: "body-m"
            }, null, 8, ["text"])
          ])
        ]),
        _createVNode(BaseButton, {
          text: "Забронировать",
          "padding-y": "18",
          "padding-x": "67",
          type: "subtitle4-m",
          color: "var(--base-white)",
          ui: "green",
          onClick: toggleForm
        })
      ]),
      (toggle.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(TourForm, { onClose: toggleForm })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseTypography, {
          text: "Программа",
          type: "subtitle-m"
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tour.value?.data.attributes.tourDescription, (desc) => {
        return (_openBlock(), _createElementBlock("div", {
          key: desc.id,
          class: "flex flex-col w-full mb-12 px-6 items-center gap-y-4"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(BaseTypography, {
                text: desc.title,
                type: "special-body",
                color: "var(--primary-color)"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                innerHTML: _unref(md).render(desc.dayDescription)
              }, null, 8, _hoisted_17)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(desc.dayImgs?.data, (img) => {
            return (_openBlock(), _createElementBlock("div", {
              key: img.id,
              class: "flex items-center gap-x-10"
            }, [
              _createElementVNode("img", {
                src: _unref(strapiUrl) + img.attributes.url,
                class: "h-[216px] w-[216px] rounded-full object-cover"
              }, null, 8, _hoisted_18)
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _createElementVNode("section", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(BaseTypography, {
          text: "Часто задаваемые вопросы",
          type: "subtitle-m"
        })
      ]),
      _createVNode(BaseAccordion, {
        title: "Как забронировать и оплатить",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(BaseTypography, {
              text: "Шаг 1: отправить заявку",
              type: "body2-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "Забронировать тур вы можете следующим образом:",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "- нажать кнопку «ЗАБРОНИРОВАТЬ» в описании тура;",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "- написать на почтовый адрес reserv@rvm-spb.ru;",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "- отправить запрос по электронной почте info@rvm-spb.ru.",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "Шаг 2: оплатить билеты",
              type: "body2-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "У вас есть 2 способа сделать это:",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "1) Удалённо, через различные системы оплат (расчет с использованием реквизитов банковской карты, переводом через интернет-банк).",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "2) Подъехать заранее к нам в офис и оплатить наличными или по картам VISA, Mastercard, МИР. Наш офис в Бизнес центре 'Петровский форт', Финляндский проспект 4А, офис 201",
              type: "body-m",
              class: "mb-6"
            }),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: "Внимание! ",
                type: "body2-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "Заявка на тур подтверждается только специалистом компании.",
                type: "body-m",
                tag: "span"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Способ оплаты",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_22, [
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Visa",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "MasterCard",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Сбербанк",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "ВТБ",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Тинькофф",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Наличными",
                type: "body-m"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Сроки оплаты тура",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(BaseTypography, {
              text: "Сроки оплаты тура указываются в договоре, который заключается после подтверждении бронирования тура.",
              type: "body-m"
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Условия отмены бронирования",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(BaseTypography, {
              text: "Условия отмены бронирования указываются в договоре, который заключается после подтверждении бронирования тура.",
              type: "body-m"
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})